import React from 'react';
import { useTranslation } from 'react-i18next';
import { editorStore } from '../../../../store/editorStore';
import { RulerLineType } from '../../../../types/floorplannerTypes';
import DimensionField from '../components/DimensionField';
import MetricsSection from '../components/MetricsSection';
import UnitHeader from '../components/UnitHeader';
import type { PropertyPanelController } from '../types';
import { panelObjectTitleRowClassName } from '../propertyPanelUtils';

type RulerLineSectionProps = Pick<PropertyPanelController, 'rulerLength' | 'setRulerLength' | 'updateGlobalState'> & {
  selectedRulerLines: RulerLineType[];
  displayedRulerLines: RulerLineType[];
  commonRulerLength?: number;
};

const RulerLineSection: React.FC<RulerLineSectionProps> = ({
  selectedRulerLines,
  displayedRulerLines,
  commonRulerLength,
  rulerLength,
  setRulerLength,
  updateGlobalState,
}) => {
  const { t } = useTranslation();
  const mixed = t('common.mixed');

  return (
    <>
      {displayedRulerLines.map((ruler) => (
        <div key={`rulerLine-${ruler?.id}`}>
          <div className={panelObjectTitleRowClassName}>
            <UnitHeader title={selectedRulerLines.length > 1 ? t('propertyPanel.multipleRulerLines', { count: selectedRulerLines.length }) : t('measure.rulerLine')} />
          </div>
          <MetricsSection>
            <div className="flex items-center justify-between py-2">
              <DimensionField
                id="rulerLength"
                label={t('propertyPanel.length')}
                value={selectedRulerLines.length > 1 ? (commonRulerLength ?? '') : rulerLength}
                placeholder={selectedRulerLines.length > 1 ? mixed : undefined}
                onChange={(nextValue) => {
                  const parsedValue = parseFloat(nextValue);
                  if (nextValue === '' || isNaN(parsedValue) || parsedValue < 0) {
                    setRulerLength('');
                    return;
                  }

                  setRulerLength(parsedValue);
                  updateGlobalState(ruler?.id, 'length', parsedValue);
                }}
                onKeyDown={(event) => {
                  if (event.key === 'Enter') {
                    if (rulerLength !== '') {
                      updateGlobalState(ruler?.id, 'length', rulerLength);
                    }
                    editorStore.setRulerEditingLengthPanel(undefined);
                  }
                }}
              />
            </div>
          </MetricsSection>
          <div className="border-b border-gray-300" />
        </div>
      ))}
    </>
  );
};

export default RulerLineSection;
